import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import { path } from 'ramda'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  userConfirmationSuccess: ['authData'],

  googleLoginRequest: ['authData'],

  loginRequest: ['email', 'password'],
  loginSuccess: ['authData', 'userData', 'redirectTo'],
  loginFailure: ['error'],
  logoutRequest: [],
  logoutSuccess: [],
  logoutFailure: ['error'],

  signupRequest: ['email', 'password', 'teamName'],
  signupSuccess: ['authData', 'userData'],
  signupFailure: ['error'],

  forgotPasswordRequest: ['email'],
  forgotPasswordSuccess: ['authData'],
  forgotPasswordFailure: ['error'],

  profileUpdateRequest: ['updateParams'],
  profileUpdateSuccess: ['updateData'],
  profileUpdateFailure: ['updateError'],

  resetPasswordRequest: ['params', 'headers', 'redirectTo'],
  resetPasswordSuccess: ['authData'],
  resetPasswordFailure: ['error'],

  setNameAndEmail: ['email', 'name'],

  profileRequest: [],
  profileSuccess: ['userData'],
  profileFailure: ['error'],

  authReset: [],
})

export const AuthTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  authData: {},
  userData: {},
  fetching: null,
  error: null,
  email: '',
  name: '',
  redirectTo: '/projects',

  updateData: {},
  updateFetching: null,
  updateError: null
})

/* ------------- Reducers ------------- */

// request the data for a auth
export const request = (state) =>
  state.merge({
    fetching: true, authData: {}, userData: {}, error: null })

export const success = (state, {
  authData = {}, userData = {} , redirectTo
}) =>
  state.merge({
    fetching: false, authData, userData,
    redirectTo: redirectTo || state.redirectTo
  })

// failed data lookup
export const failure = (state, { error }) => {
  return state.merge({ fetching: false, error })
}

export const updateRequest = (state) =>
  state.merge({ updateFetching: true, updateError: null })

export const updateSuccess = (state, { updateData }) =>
  state.merge({ updateFetching: false, userData: updateData })

export const updateFailure = (state, { updateError }) => {
  return state.merge({ updateFetching: false, updateError })
}

export const setNameAndEmail = (state, {name, email}) =>
  state.merge({name, email})

export const profileRequest = (state) =>
  state.merge({ fetching: true, error: null })

export const profileSuccess = (state, { userData }) =>
  state.merge({ fetching: false, userData })

export const profileFailure = (state, { error }) => {
  return state.merge({ fetching: false, error })
}

export const reset = (state) => state.merge(INITIAL_STATE)

/* ------------- Selectors ------------- */

export const AuthSelectors = {
  authData: state => path(['authData'], state.auth),
  userData: state => path(['userData'], state.auth)
}

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.LOGIN_REQUEST]: request,
  [Types.LOGIN_SUCCESS]: success,
  [Types.LOGIN_FAILURE]: failure,
  [Types.LOGOUT_SUCCESS]: reset,
  [Types.LOGOUT_FAILURE]: failure,

  [Types.SIGNUP_REQUEST]: request,
  [Types.SIGNUP_SUCCESS]: success,
  [Types.SIGNUP_FAILURE]: failure,

  [Types.FORGOT_PASSWORD_REQUEST]: request,
  [Types.FORGOT_PASSWORD_SUCCESS]: success,
  [Types.FORGOT_PASSWORD_FAILURE]: failure,

  [Types.PROFILE_UPDATE_REQUEST]: updateRequest,
  [Types.PROFILE_UPDATE_SUCCESS]: updateSuccess,
  [Types.PROFILE_UPDATE_FAILURE]: updateFailure,

  [Types.RESET_PASSWORD_REQUEST]: request,
  [Types.RESET_PASSWORD_SUCCESS]: success,
  [Types.RESET_PASSWORD_FAILURE]: failure,

  [Types.SET_NAME_AND_EMAIL]: setNameAndEmail,

  [Types.PROFILE_REQUEST]: profileRequest,
  [Types.PROFILE_SUCCESS]: profileSuccess,
  [Types.PROFILE_FAILURE]: profileFailure,

  [Types.AUTH_RESET]: reset

})



// WEBPACK FOOTER //
// ./src/Redux/AuthRedux.js